module.exports = __webpack_public_path__ + "statics/img/goal-add.3dddc6fa.png";